const user_scopes = {
    descriptions: {
        custom_data: 'داده‌های سفارشی شما',
        email: 'نشانی ایمیل شما',
        phone: 'شماره تلفن شما',
        profile: 'نام، نام کاربری، تصویر پروفایل و سایر اطلاعات نمایه شما',
        roles: 'نقش‌های شما',
        identities: 'هویت‌های اجتماعی پیوندخورده شما',
        'urn:logto:scope:organizations': 'اطلاعات سازمان‌های شما',
        'urn:logto:scope:organization_roles': 'نقش‌های سازمانی شما',
        address: 'نشانی شما',
        'urn:logto:scope:sessions': 'نشست‌های فعال شما',
    },
};
export default Object.freeze(user_scopes);
